import { withClient } from '@/utils/helpers/withClient'
import { PropsWithChildren } from 'react'

export const Contentwrapper = withClient<PropsWithChildren>(({ children }) => (
  <>{children}</>
))
